import {Box, CardContent, CircularProgress, Typography} from "@mui/material";
import React, {useEffect, useState} from 'react';
import {useGetVoucherQuery} from "../../core/api/seniority-api";
import Card from "@mui/material/Card";
import ProductCard from "../Shop/ProductCard";
import SeniorityCard from "./SeniorityCard";
import {Alert} from "@mui/lab";

export default function Seniority (props) {
    const [state, setState] = useState({
        isVoucherAvailable: false,
        voucher: {}
    })
    const {data: voucherResponse, isSuccess, isLoading} = useGetVoucherQuery();

    useEffect(() => {
        if (isSuccess) {
            if (voucherResponse === null) {
                setState({
                    ...state,
                    isVoucherAvailable: false,
                    voucher: voucherResponse
                })
            } else {
                setState({
                    ...state,
                    isVoucherAvailable: !voucherResponse.isActivated,
                    voucher: voucherResponse
                })
            }
        }
    }, [voucherResponse])


    return (
        isLoading ?
                <CircularProgress/> :
                <Box>
                    {state.isVoucherAvailable ?
                    <Box>
                        <Typography sx={{mb: 3, textAlign:'center',pt:1}} gutterBottom variant="body1" component="h3">
                            Congratulations on your work anniversary at Belka Games!
                        </Typography>

                        <Alert severity={"warning"}>

                            <p>This tab will be available for 1 month.
                                <br />During this period you will be able to make your choice.
                            <br />If you don't make a choice yourself, the system will automatically credit 10 belcoins to your account!</p>

                        </Alert>
                        <Box sx={{display: "flex"}}>
                            <SeniorityCard
                                voucher={state.voucher}
                                isPresent={true}
                                title={"Anniversary gift"}
                            />
                            <SeniorityCard
                                voucher={state.voucher}
                                isPresent={false}
                                title={"10 belcoins"}
                            />
                        </Box>

                    </Box>:
                    <Box sx={{m: 2}}>
                        You currently have no Seniority program offers
                    </Box>
                    }
                </Box>
    );
}